/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Lifts_TitleInputs */

const en_us2_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated max load`)
};

const pt_br2_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga máxima estimada`)
};

const es_419_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso máximo estimado`)
};

const pt_pt2_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga máxima estimada`)
};

const fr_fr2_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge max estimée`)
};

const de_de2_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Maximallast`)
};

const it_it2_progress_lifts_title = /** @type {(inputs: Progress_Lifts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carico massimo stimato`)
};

/**
* | output |
* | --- |
* | "Estimated max load" |
*
* @param {Progress_Lifts_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_title = /** @type {((inputs?: Progress_Lifts_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_title(inputs)
	if (locale === "es-419") return es_419_progress_lifts_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_title(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_title(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_title(inputs)
	return en_us2_progress_lifts_title(inputs)
});
export { progress_lifts_title as "progress.lifts_title" }